/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import type { LiferayError, Translate } from 'types';
import styles from './styles.module.scss';

const ErrorMessage = (props: LiferayError & { t: Translate }): React$Element<any> => {
  return (
    <div className={styles.error}>
      {props.message || props.t('GENERIC_ERROR')} {props.code ? ` [errorCode=${props.code}]` : null}
    </div>
  );
};

export default withTranslation()(ErrorMessage);
